var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-ignore
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Component, { mixins } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import Toast from '@/mixin/toast';
import { DefaultPagination, PaginationDecorator } from '@/data-types/pagination';
import { BButton, BCol, BForm, BFormInput, BFormTextarea, BInputGroup, BInputGroupText, BModal, BRow, BSpinner, VBTooltip, } from 'bootstrap-vue';
import HumanizeDate from '@/components/HumanizeDate.vue';
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue';
import LocaleMixin from '@/mixin/locale';
import { v4 as uuid } from 'uuid';
import { AIQuestionSummaryStatusEnum, LocaleEnum } from '@vini-wine/core-enums';
let AiBubbleBottom = class AiBubbleBottom extends mixins(Toast, LocaleMixin) {
    constructor() {
        super(...arguments);
        this.paginationAiThreads = new DefaultPagination();
        this.paginationSelectedAiThreadQuestions = new DefaultPagination();
        this.aiThreads = [];
        this.selectedAiThread = null;
        this.selectedAiThreadQuestions = [];
        this.loadingSelectedAiThreadQuestions = false;
        this.sendingMessageToAiThread = false;
        this.loadingAiThreads = true;
        this.pageQueryAiThreads = { perPage: 10, currentPage: 1 };
        this.pageQuerySelectedAiThreadQuestions = { perPage: 10, currentPage: 1 };
        this.MAX_SECONDS_COUNTDOWN = 125;
        this.form = {
            uuid: uuid(),
            question: '',
            language: null,
        };
        this.secondsCountdown = this.MAX_SECONDS_COUNTDOWN;
        this.secondsCountdownInterval = null;
    }
    get currentOrganisationUuid() {
        return this.$store.state.admin.user.currentOrganisationUuid;
    }
    async onModalShow() {
        this.form.language = this.currentLocale;
        this.aiThreads = await this.loadAiThreads();
        this.focusAiChatInput();
    }
    async loadAiThreads() {
        this.loadingAiThreads = true;
        const response = await this.adminApi.getOrganisationThreads(this.currentOrganisationUuid, {
            page: this.pageQueryAiThreads.currentPage,
            perPage: this.pageQueryAiThreads.perPage,
        });
        this.loadingAiThreads = false;
        if (response.isError()) {
            this.errorToast(response.message);
            return [];
        }
        return new PaginationDecorator(this.paginationAiThreads)
            .defaultFromResponse(response.data)
            .getPage();
    }
    async selectAiThread(aiThread) {
        this.selectedAiThreadQuestions = [];
        this.selectedAiThread = aiThread;
        this.loadingSelectedAiThreadQuestions = true;
        const response = await this.adminApi.getOrganisationThreadQuestions(this.currentOrganisationUuid, aiThread.uuid, this.pageQuerySelectedAiThreadQuestions);
        this.loadingSelectedAiThreadQuestions = false;
        if (response.isError()) {
            this.errorToast(response.message);
            return [];
        }
        this.resetQuestionForm();
        this.selectedAiThreadQuestions = new PaginationDecorator(this.paginationSelectedAiThreadQuestions)
            .defaultFromResponse(response.data)
            .getPage();
        this.$nextTick(() => this.scrollToBottom());
        this.focusAiChatInput();
        return this.selectedAiThreadQuestions;
    }
    resetQuestionForm() {
        this.form = {
            uuid: uuid(),
            question: '',
            language: this.currentLocale,
        };
        if (this.selectedAiThread) {
            this.form.thread = {
                uuid: this.selectedAiThread.uuid,
            };
        }
    }
    addQuestionImmediatelyToSelectedThread() {
        const lastQuestion = {
            uuid: 'test-question-uuid',
            language: {
                id: this.form.language ? this.form.language : LocaleEnum.ENGLISH,
            },
            question: this.form.question,
            summaryStatus: {
                id: AIQuestionSummaryStatusEnum.PENDING,
            },
            summary: null,
            summaryReceivedAt: null,
            createdAt: new Date().toISOString(),
        };
        if (!this.selectedAiThread) {
            this.selectedAiThread = {
                uuid: 'test-thread-uuid',
                createdAt: new Date().toISOString(),
                lastAIQuestion: lastQuestion,
            };
            this.aiThreads.unshift(this.selectedAiThread);
        }
        this.selectedAiThreadQuestions.push(lastQuestion);
    }
    startCountdown() {
        this.secondsCountdownInterval = setInterval(() => {
            if (this.secondsCountdown === 0) {
                clearInterval(this.secondsCountdownInterval);
                return;
            }
            this.secondsCountdown -= 1;
        }, 1000);
    }
    async createOrganisationThreadQuestion() {
        this.addQuestionImmediatelyToSelectedThread();
        this.startCountdown();
        this.$nextTick(() => this.scrollToBottom());
        this.sendingMessageToAiThread = true;
        const response = await this.adminApi.createOrganisationThreadQuestion(this.currentOrganisationUuid, this.form);
        this.sendingMessageToAiThread = false;
        if (response.isError()) {
            this.errorToast(response.message);
        }
        else {
            this.selectedAiThread = response.data.thread;
            this.aiThreads.shift();
            this.aiThreads.unshift({
                ...response.data.thread,
                lastAIQuestion: response.data,
            });
            this.selectedAiThreadQuestions.pop();
            this.selectedAiThreadQuestions.push(response.data);
            this.secondsCountdown = this.MAX_SECONDS_COUNTDOWN;
            clearInterval(this.secondsCountdownInterval);
            this.$nextTick(() => this.scrollToBottom());
            this.resetQuestionForm();
            setTimeout(() => this.focusAiChatInput(), 500);
        }
    }
    scrollToBottom() {
        this.$nextTick(() => {
            if (this.$refs.chatContentRef) {
                const chatContainer = this.$refs.chatContentRef.$el;
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        });
    }
    focusAiChatInput() {
        this.$refs.chatAiTextareaRef.focus();
    }
    onClose() {
        this.aiThreads = [];
        this.selectedAiThread = null;
        this.selectedAiThreadQuestions = [];
        this.resetQuestionForm();
    }
    startNewThread() {
        this.selectedAiThread = null;
        this.selectedAiThreadQuestions = [];
        this.resetQuestionForm();
    }
    async onTextareaKeydown(e) {
        if (e.key === 'Enter') {
            if (e.shiftKey) {
                return;
            }
            e.preventDefault();
            await this.createOrganisationThreadQuestion();
        }
    }
    formatSummary(summary) {
        let text = summary ?? '';
        text = text.replace(/\\"/g, '"');
        text = text.replace(/\\n/g, '<br />');
        return text;
    }
};
__decorate([
    Inject('adminApi')
], AiBubbleBottom.prototype, "adminApi", void 0);
AiBubbleBottom = __decorate([
    Component({
        computed: {
            AIQuestionSummaryStatusEnum() {
                return AIQuestionSummaryStatusEnum;
            },
        },
        components: {
            Locale,
            BButton,
            HumanizeDate,
            BSpinner,
            BModal,
            BRow,
            VuePerfectScrollbar,
            BCol,
            BForm,
            BFormTextarea,
            BInputGroup,
            BFormInput,
            BInputGroupText,
        },
        directives: {
            'b-tooltip': VBTooltip,
        },
    })
], AiBubbleBottom);
export default AiBubbleBottom;
